import moment from "moment";
import { MONTHS } from "./constants";

export const formQueryString = (object: any): string => {
    if (!object) return '';
    return Object.keys(object)
        .filter((key: string) => object[key] !== undefined && object[key] !== null && object[key] !== 'undefined' && object[key] !== 'null')
        .map((key: string) => `${key}=${object[key]}`)
        .join('&');
}

export const lastYears = (n: number) => {
    const currentYear = new Date().getFullYear();
    const range = (start: number, stop: number, step: number) => Array.from({ length: (stop - start) / step + 1 }, (_, i) => ({
        label: '' + (start + (i * step)),
        value: start + (i * step)
    }));
    return range(currentYear, currentYear - n, -1)
}

export const lastInclomeTaxYears = (n: number) => {
    const currentYear = new Date().getFullYear();
    const range = (start: number, stop: number, step: number) => Array.from({ length: (stop - start) / step + 1 }, (_, i) => ({
        label: '' + (start + (i * step)) + ' - ' + (start + (i * step) + 1),
        value: start + (i * step)
    }));
    return range(currentYear, currentYear - n, -1)
}

export const nextYears = (n: number) => {
    const currentYear = new Date().getFullYear();
    const startYear = currentYear - 1;
    const range = (start: number, stop: number, step: number) => Array.from({ length: (stop - start) / step + 1 }, (_, i) => ({
        label: '' + (start + (i * step)),
        value: start + (i * step)
    }));
    return range(startYear, currentYear + n, 1)
}

export const nextInclomeTaxYears = (n: number) => {
    const currentYear = new Date().getFullYear();
    const startYear = currentYear - 1;
    const range = (start: number, stop: number, step: number) => Array.from({ length: (stop - start) / step + 1 }, (_, i) => ({
        label: '' + (start + (i * step)) + ' - ' + (start + (i * step) + 1),
        value: start + (i * step)
    }));
    return range(startYear, currentYear + n, 1)
}

// headerHeight:  114  pageTitleHeight:  74  pageFilterHeight:  45  pageFooterHeight:  52  windowHeight:  687

export const calculateMaxHeightContent = (extraMarginPadding: number = 0): number => {
    const headerHeight = document.getElementById('ux_page_header')?.offsetHeight || 0;
    const pageTitleHeight = document.getElementById('ux_page_title')?.offsetHeight || 0;
    const pageFilterHeight = document.getElementById('ux_page_filter')?.offsetHeight || 0;
    const pageFooterHeight = document.getElementById('ux_page_footer')?.offsetHeight || 0;

    const windowHeight = window.innerHeight;

    return windowHeight - (headerHeight + pageTitleHeight + pageFooterHeight + pageFilterHeight + extraMarginPadding);

}

export const transformMonths = (): any[] => {
    return MONTHS.map((record: any) => ({ value: +record['value'], label: record['label'] }))
}

export const capitalizeFirstCharacter = (str: string) => {
    return str.charAt(0).toUpperCase() + str.substr(1)
}

export const fileDownloadBlob = (blob: Blob, fileName: string) => {
    // Create a blob URL
    const blobUrl = window.URL.createObjectURL(new Blob([blob], { type: 'application/pdf' }));

    // Create a temporary anchor element
    const link = document.createElement('a');
    link.href = blobUrl;

    // Set the download attribute with a filename
    link.download = fileName;

    // Append the link to the body
    document.body.appendChild(link);

    // Programmatically click the link to trigger the download
    link.click();

    // Remove the link from the document
    document.body.removeChild(link);

    // Optionally, revoke the object URL to release memory
    window.URL.revokeObjectURL(blobUrl);
}

export const fileDownloadLink = (url: string, fileName: string) => {
    // Create a blob URL

    // Create a temporary anchor element
    const link = document.createElement('a');
    link.href = url;

    // Set the download attribute with a filename
    link.download = fileName;

    // Append the link to the body
    document.body.appendChild(link);

    // Programmatically click the link to trigger the download
    link.click();

    // Remove the link from the document
    document.body.removeChild(link);
}

export const formatNumber = (input: string) => {
    // Handle empty or non-numeric input
    if (input === '' || input === '-' || input === '.') return input;

    // Check if the user is typing a decimal number
    const parts = input.split('.'); // Split the number by the decimal point
    const integerPart = parts[0].replace(/[^0-9.-]/g, '');

    // If only the integer part is entered or there's no decimal part yet
    if (parts.length === 1) {
        const intData = parseInt(integerPart).toLocaleString('en-US');
        return intData +'.00';
    }

    // If the user is typing after the decimal point
    const decimalPart = (parts[1] + '00').substring(0, 2); // Ensure at least two decimal places

    if ( integerPart == '' ) {
        return '.' + decimalPart;
    } else {
        const intData = parseInt(integerPart).toLocaleString('en-US');
        return intData + '.' +decimalPart;
    }
    
};

export const unformatNumber = (input: string) => {
    return parseFloat( input.replaceAll(',','') );
};

/**
 * Backend timestamps are UTC. `transaction_at` represents a calendar date only
 * (not a specific moment in time), so it's formatted in UTC and without a time
 * component to avoid the date shifting when the browser's local timezone differs.
 */
export const formatTransactionDate = (value: any) => {
    if (!value) return '';
    return moment.utc(value).format('MM-DD-YYYY');
}

export const usdCurrencyFormat = (price: number) => {
    // Without round off
    // Number(Math.floor(parseFloat(''+price) * 100) / 100).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 });

    // With round off
    // Number(parseFloat(''+price).toFixed(2)).toLocaleString();

    var convertedNumber = Number(Math.floor(Math.round(parseFloat(''+price) * 100)) / 100).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    const parts = convertedNumber.split('.');
    return '$ ' + parts[0] + '.' + (parts[1] || '0').padEnd(2, '0');
}

/**
 * Helper permission utilities for GL Dashboard access control
 */
export interface GLDashboardPermissions {
    classification?: {
        deposit_classification?: boolean;
        expense_classification?: boolean;
        revenue_classification?: boolean;
        credit_card_classification?: boolean;
        bank_reconciliation?: boolean;
    };
    maintenance?: {
        manage_chart_of_accounts?: boolean;
        change_existing_account?: boolean;
        add_new_account?: boolean;
        transaction_register?: boolean;
        budget_entry?: boolean;
        beginning_balance_entry?: boolean;
        qbo_vendors?: boolean;
        qbo_customers?: boolean;
    };
    forms?: {
        '433_b'?: boolean;
        personal_income_statement?: boolean;
        personal_balance_sheet?: boolean;
    };
    reports?: {
        bank_transaction_history?: boolean;
        sales_transaction_history?: boolean;
        balance_sheet?: boolean;
        statement_of_income_loss?: boolean;
        business_ratios?: boolean;
        budget_vs_actual?: boolean;
        five_year_forecast?: boolean;
    };
    taxResolution?: {
      "form_433A"?: boolean,
      "form_433A_OIC"?: boolean,
      "form_433B"?: boolean,
      "form_433B_OIC"?: boolean,
      "form_433D"?: boolean,
      "form_433F"?: boolean,
      "publication_5059"?: boolean,
      "publication_1854"?: boolean,
    }

}

/**
 * Check if user has permission to view a specific section
 * @param permissions - Helper permissions object
 * @param section - Section name (classification, maintenance, forms, reports)
 * @returns true if any permission in the section is true
 */
export const canViewSection = (permissions: any, section: keyof GLDashboardPermissions): boolean => {
    if (!permissions || !permissions['gl-dashboard']) return true; // No restrictions for non-helper users
    const sectionPermissions = permissions['gl-dashboard'][section];
    if (!sectionPermissions) return false;
    return Object.values(sectionPermissions).some(Boolean);
};

/**
 * Check if user has permission for a specific feature
 * @param permissions - Helper permissions object
 * @param section - Section name (classification, maintenance, forms, reports)
 * @param feature - Feature name within the section
 * @returns true if the specific permission is true
 */
export const hasPermission = (permissions: any, section: keyof GLDashboardPermissions, feature: string): boolean => {
    if (!permissions || !permissions['gl-dashboard']) return true; // No restrictions for non-helper users
    const sectionPermissions = permissions['gl-dashboard'][section];
    if (!sectionPermissions) return false;
    
    // Check the original feature key first
    if (sectionPermissions[feature] === true) return true;
    
    // Compatibility layer: check alternative key format for '433b' vs '433_b'
    // Backend returns '433_b' but UI expects '433b'
    if (feature === '433b' && sectionPermissions['433_b'] === true) return true;
    
    return false;
};

/**
 * Clear all classification skipped steps from localStorage.
 * Used when switching users/SSO or navigating to Scoreboard (RevRex App).
 */
export const clearClassificationSkippedStorage = () => {
    try {
        if (typeof window !== 'undefined' && window.localStorage) {
            const keysToRemove: string[] = [];
            for (let i = 0; i < window.localStorage.length; i++) {
                const key = window.localStorage.key(i);
                if (key && key.startsWith('gl_classification_skipped_')) {
                    keysToRemove.push(key);
                }
            }
            Object.keys(window.localStorage).forEach((key) => {
                if (key.startsWith('gl_classification_skipped_') && !keysToRemove.includes(key)) {
                    keysToRemove.push(key);
                }
            });
            keysToRemove.forEach((key) => window.localStorage.removeItem(key));
        }
    } catch (e) {
        // ignore localStorage access errors
    }
};
